import { useEffect, useState } from 'react';
import styles from '../animation.module.css';
// Animation styles loaded only when component is used

const Warning = ({ size }) => {
  const [toggleAnimation, setToggleAnimation] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setToggleAnimation(!toggleAnimation);
    }, 2000);
  }, [toggleAnimation]);

  return (
    <svg
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      className={`${styles.warning} ${toggleAnimation ? styles.toggle : ''}`}
    >
      <circle
        className="solid"
        fill="none"
        strokeLinecap="round"
        strokeWidth="4"
        strokeMiterlimit="10"
        cx="32"
        cy="32"
        r="30"
      />
      <circle
        className="animation"
        fill="none"
        strokeLinecap="round"
        strokeWidth="4"
        strokeMiterlimit="10"
        cx="32"
        cy="32"
        r="30"
      />
      <path
        fill="none"
        stroke="#000"
        strokeWidth="6"
        strokeLinecap="round"
        strokeMiterlimit="10"
        d="M32 15v20"
      />
      <line
        fill="none"
        stroke="#000"
        strokeWidth="8"
        strokeLinecap="round"
        strokeMiterlimit="10"
        x1="32"
        y1="46"
        x2="32"
        y2="46"
      />
    </svg>
  );
};

export default Warning;
